// removed by extract-text-webpack-plugin
module.exports = {"selected_checkbox":"styles__selected_checkbox___3RFJV","arrow_up":"styles__arrow_up___1PDEs","display_image":"styles__display_image___2Xfuj","box_protocols":"styles__box_protocols___pXcPx","box_protocols_display":"styles__box_protocols_display___3aQOr","protocol_number":"styles__protocol_number___1rgWy","display_align":"styles__display_align___yq6ys","custom_checkbox":"styles__custom_checkbox___dmAtr","error":"styles__error___kQVKO","portabilityFormClass":"styles__portabilityFormClass___3GC1a"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/ActionForm/PortabilityEdit/styles.css
// module id = 3171
// module chunks = 0